import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import F1Logo from './F1Logo'
import './Navbar.css'

const Navbar = () => {
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const primaryNavItems = [
    { path: '/all-time', label: 'All-Time Ratings' },
    { path: '/current-grid', label: 'Current Grid' },
    { path: '/comparison', label: 'Compare' },
    { path: '/timeline', label: 'Timeline' }
  ]

  const utilityNavItems = [
    { path: '/methodology', label: 'Methodology' },
    { path: '/about-model', label: 'About Model' },
    { path: '/faq', label: 'FAQ' }
  ]

  const mobileNavItems = [...primaryNavItems, ...utilityNavItems]

  const isActivePath = (path) => {
    if (path === '/comparison') {
      return location.pathname === '/comparison' || location.pathname.startsWith('/compare/')
    }
    return location.pathname === path
  }

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen)

  return (
    <nav className="navbar">
      <div className="navbar-meta" aria-label="F1 ELO archive metadata">
        <div className="navbar-meta-inner">
          <span>F1 Elo Archive</span>
          <span>Est. 1950</span>
          <span>1950 - 2026</span>
          <span>699 Drivers</span>
          <span>24,946 Results</span>
          <div className="navbar-utility-links" aria-label="Model navigation">
            {utilityNavItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`navbar-utility-link ${isActivePath(item.path) ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <F1Logo className="logo-f1-icon" ariaLabel="Formula 1" />
          <span className="logo-text">ELO</span>
          <span className="logo-divider" aria-hidden="true" />
          <span className="logo-badge">
            <span>The</span>
            <span>Rankings</span>
          </span>
        </Link>

        <ul className="navbar-menu">
          {primaryNavItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`navbar-link ${isActivePath(item.path) ? 'active' : ''}`}
              >
                {item.label}
                {isActivePath(item.path) && (
                  <motion.div
                    className="active-indicator"
                    layoutId="activeIndicator"
                    transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                  />
                )}
              </Link>
            </li>
          ))}
        </ul>

        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label={mobileMenuOpen ? 'Close site navigation' : 'Open site navigation'}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              className="mobile-menu"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
            >
              {mobileNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`mobile-link ${isActivePath(item.path) ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  )
}

export default Navbar
